export const getAllTypeTwoPayrolls = `
query allTypeTwoPayroll{
  allTypeTwoPayroll {
    success
    message
    data {
      id
      user {
        id
        empid
        firstName
        lastName
      }
      salaryStructureId
      yearlyCtc
      monthlyCtc
      oneDaySalary
      lossOfPayCount
      lossOfPayAmount
      totalDeductions
      netPay
      breakdown
      month
      year
    }
  }
}`;

export const createTypeTwoPayroll = `
mutation GenerateTypeTwoPayroll($month: Int!, $year: Int!) {
  generateTypeTwoPayroll(month: $month, year: $year) {
    success
    message
    payrollData{
      user{
        id
        empid
        firstName
        lastName
        dateJoined
      }
      year
      month
      monthlyCtc
      oneDaySalary
      lossOfPayCount
      lossOfPayAmount
      totalDeductions
      netPay
      breakdown
    }
  }
}`;

export const getTypeTwoPayrollById = `
query TypeTwoPayrollById($id: String!) {
  typeTwoPayrollById(id: $id) {
    success
    message
    data {
      id
      user {
        id
        empid
        firstName
        lastName
      }
      salaryStructureId
      yearlyCtc
      monthlyCtc
      oneDaySalary
      lossOfPayCount
      lossOfPayAmount
      totalDeductions
      netPay
      breakdown
      month
      year
    }
  }
}`;

// export const getTypeTwoPayrollFilter = `
// query TypeTwoPayslip(
//   $userId: Int!
//   $month: Int!
//   $year: Int!
// ) {
//   typeTwoPayslip(
//     userId: $userId
//     month: $month
//     year: $year
//   ) {
//     success
//     message
//     data {
//       id
//       user {
//         id
//         empid
//         firstName
//         lastName
//       }
//       salaryStructureId
//       yearlyCtc
//       monthlyCtc
//       oneDaySalary
//       lossOfPayCount
//       lossOfPayAmount
//       totalDeductions
//       netPay
//       breakdown
//       month
//       year
//     }
//   }
// }`;


export const getTypeTwoPayrollByMonthYear = `
query TypeTwoPayrollByMonthYear(
  $month: Int!
  $year: Int!
) {
  typeTwoPayrollByMonthYear(
    month: $month
    year: $year
  ) {
    success
    message
    data {
      id
      user {
        id
        empid
        firstName
        lastName
      }
      salaryStructureId
      yearlyCtc
      monthlyCtc
      oneDaySalary
      lossOfPayCount
      lossOfPayAmount
      totalDeductions
      netPay
      breakdown
      month
      year
    }
  }
}`;